import { httpPost, httpGet } from "utils/httpRequest"

const listAiVoices = async ({ page = 1, pageSize = 200 } = {}) => {
  const resp = await httpPost("admin/aiVoice/list", { page, pageSize })
  return resp.data
}

const getAiVoiceById = async (id) => {
  const resp = await httpPost("admin/aiVoice/getById", { id })
  return resp.data
}

const addAiVoice = async (voiceData) => {
  const resp = await httpPost("admin/aiVoice/add", voiceData)
  return resp.data
}

const editAiVoice = async (voiceData) => {
  const resp = await httpPost("admin/aiVoice/edit", voiceData)
  return resp.data
}

const deleteAiVoice = async (id) => {
  const resp = await httpPost("admin/aiVoice/delete", { id })
  return resp.data
}

// Ask backend to fetch provider voices (OpenAI, ElevenLabs, etc.)
const getProviderVoices = async (provider, params = {}) => {
  const resp = await httpPost("admin/aiVoice/getProviderVoices", { provider, ...params })
  return resp.data
}

export {
  listAiVoices,
  getAiVoiceById,
  addAiVoice,
  editAiVoice,
  deleteAiVoice,
  getProviderVoices,
}
